import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe } from '@cmi/addin-core';
import { Button, Notification } from '@cmi/ui';
import { map } from 'rxjs';
import { FilingsService } from '../filings.service';
import { MAX_FILINGS } from '../mail-upload/mail-upload.models';
import { FiledHeading } from './filed-heading';
import { FiledTargets } from './filed-targets';

/**
 * Where the open mail was filed: the confirmation right after filing
 * (`?justFiled=true`), and what a mail filed earlier opens on.
 */
@Component({
  selector: 'cmi-filed-view',
  imports: [TranslatePipe, Button, Notification, FiledHeading, FiledTargets],
  templateUrl: './filed-view.html',
  host: { class: 'mt-4 block' }
})
export class FiledView {
  private readonly _router = inject(Router);

  /** Every target the mail went to, newest first. */
  protected readonly filings = inject(FilingsService).filings;
  /** True for a mail filed before the pane was opened on it, rather than just now. */
  protected readonly alreadyFiled = toSignal(
    inject(ActivatedRoute).queryParamMap.pipe(map((params) => params.get('justFiled') !== 'true')),
    { initialValue: true }
  );

  /** At the limit the mail cannot be filed again, so the button makes way for a note. */
  protected readonly limitReached = computed(() => this.filings().length >= MAX_FILINGS);
  protected readonly maxFilings = { max: String(MAX_FILINGS) };

  protected onFileAnother(): void {
    void this._router.navigate(['/file']);
  }
}
